export const sortFields = {
  Distance: { field: 'distance', dir: 'asc' },
  'Property Name A-Z': { field: 'name', dir: 'asc' },
  'Property Name Z-A': { field: 'name', dir: 'desc' },
} as const;
